const aside = document.querySelector('aside');
document.querySelector('.mobile-menu-button')?.addEventListener('click', () => {
    aside.classList.toggle('open');
});